import { render } from "./EmbedPosition.vue?vue&type=template&id=3272a4ea&scoped=true"
import script from "./EmbedPosition.vue?vue&type=script&lang=ts"
export * from "./EmbedPosition.vue?vue&type=script&lang=ts"

import "./EmbedPosition.vue?vue&type=style&index=0&id=3272a4ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3272a4ea"

export default script